<template>
  <div>
    <div class="whatsapp-preview-container" v-html="parsedMessage"></div>
    <br />
    <span class="whatsapp-preview-container">Para deixar de receber ofertas, envie #sair.</span>
  </div>
</template>

<script>
import { variablesInspection } from '@/modules/maria/campanha-da-maria-v2/mixins/variables-inspection.js'

export default {
  name: 'WhatsappPreview',
  mixins: [variablesInspection],
}
</script>

<style lang="scss" scoped>
.whatsapp-preview-container {
  font-size: 14px;
  color: $cinza-d10;
  max-width: 100%;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  white-space: normal;
}

::v-deep .variable-style {
  font-weight: bold;
  white-space: nowrap;
  color: #9747ff;
}

::v-deep .subvariable-style {
  font-weight: bold;
  white-space: nowrap;
  color: $cinza-d20;
}
</style>
